import { Box, TextField, Typography } from "@mui/material";

const linkSx = {
  textDecoration: "underline",
  color: "#FCB200",
  "&:hover": {
    cursor: "pointer",
    color: "#FCB200",
  },
};

const OtpLoginFields = ({
  values,
  touched,
  errors,
  handleBlur,
  handleChange,
  loginStep,
  otpSession,
  onEditPhoneNumber,
  onResendOtp,
  isLoading,
}) => (
  <>
    {loginStep === "requestOtp" ? (
      <TextField
        label="Contact (+256)"
        placeholder="+256712345678"
        onBlur={handleBlur}
        onChange={handleChange}
        value={values.phone_number}
        name="phone_number"
        error={Boolean(touched.phone_number) && Boolean(errors.phone_number)}
        helperText={touched.phone_number && errors.phone_number}
        sx={{ gridColumn: "span 4", borderRadius: "2rem" }}
      />
    ) : (
      <>
        <TextField
          label="Contact (+256)"
          value={otpSession.phoneNumber}
          disabled
          sx={{ gridColumn: "span 4", borderRadius: "2rem" }}
        />
        <TextField
          label="OTP Code"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.otp_code}
          name="otp_code"
          error={Boolean(touched.otp_code) && Boolean(errors.otp_code)}
          helperText={touched.otp_code && errors.otp_code}
          sx={{ gridColumn: "span 4", borderRadius: "2rem" }}
        />
        <Box sx={{ gridColumn: "span 4", display: "flex", flexDirection: "column", gap: 0.5 }}>
          <Typography
            onClick={isLoading ? undefined : onResendOtp}
            sx={{
              ...linkSx,
              opacity: isLoading ? 0.6 : 1,
              pointerEvents: isLoading ? "none" : "auto",
            }}
          >
            Request a new OTP
          </Typography>
          <Typography onClick={onEditPhoneNumber} sx={linkSx}>
            Edit phone number
          </Typography>
        </Box>
      </>
    )}
  </>
);

export default OtpLoginFields;
